var _circle, _rect, _path, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 120,
    viewBox: "0 0 200 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 75,
    r: 42,
    fill: "#EEF9F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 60,
    width: 60,
    height: 30,
    rx: 6,
    fill: "#3AC27F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 76l8 8 20-20",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 56,
    width: 10,
    height: 24,
    rx: 5,
    fill: "#D9F3E4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 56,
    width: 10,
    height: 24,
    rx: 5,
    fill: "#D9F3E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.9f9ef2a2cd37b1f8014577b79c3b3e7a.svg";
export { ForwardRef as ReactComponent };